var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:[_vm.$style.icon, _vm.$style['icon_' + _vm.iconName]]})}
var staticRenderFns = []

export { render, staticRenderFns }